import React from "react";
import { Card, CardBody, Col, Row } from "reactstrap";
import anastasia from "../../assets/img/ugph_1.jpg";

const CourseContent = () => {
  return (
    <section className="pt-3 pt-sm-8 pb-5 position-relative bg-gray-100">
      <div className="position-absolute w-100 z-index-1 top-0 mt-n3">
        <svg
          width="100%"
          viewBox="0 -2 1920 157"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <title>wave-down</title>
          <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g fill="#FFFFFF" fillRule="nonzero">
              <g id="wave-down">
                <path
                  d="M0,60.8320331 C299.333333,115.127115 618.333333,111.165365 959,47.8320321 C1299.66667,-15.5013009 1620.66667,-15.2062179 1920,47.8320331 L1920,156.389409 L0,156.389409 L0,60.8320331 Z"
                  id="Path-Copy-2"
                  transform="translate(960.000000, 78.416017) rotate(180.000000) translate(-960.000000, -78.416017) "
                />
              </g>
            </g>
          </g>
        </svg>
      </div>
      <div className="container">
        <div className="text-start mt-5">
          <h3 className="z-index-1 position-relative">Course Content</h3>
          <p className="text-dark mb-3">
            The course will provide participants with SM&E tools, techniques,
            and resources needed for planning, organizing, and managing malaria
            programs and projects. <strong>Course Duration: 3 weeks</strong>
          </p>
          {/* <Row>
            <Col xs={12} sm={12} md={5}>
              <Card className="card-background card-background-mask-warning">
                <div
                  className="full-background"
                  style={{
                    backgroundImage: "url(" + anastasia + ")",
                    opacity: "0.5",
                  }}
                />
                <CardBody>
                  <h5 className="font-weight-bolder mt-0 text-white">
                    Option 1
                  </h5>
                  <p className="pe-3 text-white">1 Week: SM&E Fundamentals</p>
                  <p className="pe-3 mb-0 text-white">
                    The first week,{" "}
                    <strong>August 21 – August 25, 2023</strong>, will
                    focus on SM&E fundamentals of malaria programs. Modules
                    include: Using Data for Decision-Making; Designing and
                    Implementing SM&E Plans; Frameworks, Indicators; Data
                    Sources; Data Quality; Evaluation Designs; Data Management
                    and Analysis; and Data Presentation, Interpretation, and Use
                  </p>
                </CardBody>
              </Card>
            </Col>
            <Col xs={12} sm={12} md={7}>
              <Card className="card-background card-background-mask-warning">
                <div
                  className="full-background"
                  style={{
                    backgroundImage: "url(" + anastasia + ")",
                    opacity: "0.5",
                  }}
                />
                <CardBody className="info">
                  <h5 className="font-weight-bolder mt-0 text-white">
                    Option 2
                  </h5>
                  <p className="pe-3 text-white">1 Week: GIS</p>
                  <p className="pe-3 mb-0 text-white">
                    The second week,{" "}
                    <strong>August 28 – September 1, 2023,</strong> will offer{" "}
                    <strong>GIS Modules, including:</strong> Introduction to
                    GIS; GIS Data – Spatial and Attribute Data; Vector and
                    Raster Data; Introduction to GIS Software (ArcGIS/QGIS);
                    Data Acquisition in GIS: Vector – GPS and Ghana Post GPS,
                    Google Earth Capture; Data Collection Using Mobile
                    Application; Digitizing Scanned Map; Raster – Satellite
                    Imagery; Google Earth; Drone captures; Data Projection;
                    Geoprocessing and Map Making; Data Visualization: Point Data
                    – Point Pattern Analysis, Interpolation, Buffering,
                    Polygon-Choropleth maps
                  </p>
                </CardBody>
              </Card>
            </Col>
            <Col xs={12} sm={12} md={5}>
              <Card className="card-background card-background-mask-warning">
                <div
                  className="full-background"
                  style={{
                    backgroundImage: "url(" + anastasia + ")",
                    opacity: "0.5",
                  }}
                />
                <CardBody className="info">
                  <h5 className="font-weight-bolder mt-0 text-white">
                    Option 3
                  </h5>
                  <p className="pe-3 text-white">
                    1 Week: Surveillance/Evaluation
                  </p>
                  <p className="pe-3 mb-0 text-white">
                    The third week,{" "}
                    <strong>September 4 – September 8, 2023</strong> will offer
                    two track options{" "}
                    <strong>(Malaria Surveillance or Evaluation
                      Methods) </strong>
                    held concurrently. Participants may choose one track per
                    year
                  </p>
                </CardBody>
              </Card>
            </Col>
          </Row> */}
          <div>
            <div>
              <Card className="card-background card-background-mask-warning">
                <div
                  className="full-background"
                  style={{
                    backgroundImage: "url(" + anastasia + ")",
                    opacity: "0.5",
                  }}
                />
                <CardBody>
                  <h5 className="font-weight-bolder mt-0 text-white">
                    Option 1
                  </h5>
                  <h6 className="pe-3 text-white">SM&E Fundamentals</h6>
                  <p className="pe-3 mb-0 text-white">
                    The first week,{" "}
                    <strong className="highlighted">August 19 – August 23, 2024</strong>, will
                    focus on SM&E fundamentals of malaria programs. Modules
                    include: Using Data for Decision-Making; Designing and
                    Implementing SM&E Plans; Frameworks, Indicators; Data
                    Sources; Data Quality; Evaluation Designs; Data Management
                    and Analysis; and Data Presentation, Interpretation, and Use
                  </p>
                </CardBody>
              </Card>
            </div>
            <div>
              <Card className="card-background card-background-mask-warning">
                <div
                  className="full-background"
                  style={{
                    backgroundImage: "url(" + anastasia + ")",
                    opacity: "0.5",
                  }}
                />
                <CardBody className="info">
                  <h5 className="font-weight-bolder mt-0 text-white">
                    Option 2
                  </h5>
                  <h6 className="pe-3 text-white">GIS</h6>
                  <p className="pe-3 mb-0 text-white">
                    The second week,{" "}
                    <strong className="highlighted">August 26 – August 30, 2024,</strong> will offer{" "}
                    <strong className="highlighted">GIS Modules, including:</strong> Introduction to
                    GIS; GIS Data – Spatial and Attribute Data; Vector and
                    Raster Data; Introduction to GIS Software (ArcGIS/QGIS);
                    Data Acquisition in GIS: Vector – GPS and Ghana Post GPS,
                    Google Earth Capture; Data Collection Using Mobile
                    Application; Digitizing Scanned Map; Raster – Satellite
                    Imagery; Google Earth; Drone captures; Data Projection;
                    Geoprocessing and Map Making; Data Visualization: Point Data
                    – Point Pattern Analysis, Interpolation, Buffering,
                    Polygon-Choropleth maps
                  </p>
                </CardBody>
              </Card>
            </div>
            <div>
              <Card className="card-background card-background-mask-warning">
                <div
                  className="full-background"
                  style={{
                    backgroundImage: "url(" + anastasia + ")",
                    opacity: "0.5",
                  }}
                />
                <CardBody className="info">
                  <h5 className="font-weight-bolder mt-0 text-white">
                    Option 3
                  </h5>
                  <h6 className="pe-3 text-white">Malaria Surveillance / Evaluation Methods</h6>
                  <p className="pe-3 mb-0 text-white">
                    The third week,{" "}
                    <strong className="highlighted">September 2 – September 6, 2024,</strong> will offer track options{" "}
                    <strong className="highlighted">(Malaria Surveillance / Evaluation Methods)</strong> held concurrently. Participants may choose one track per year.
                  </p>
                </CardBody>
              </Card>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-lg-6 col-12">
            <div className="card card-profile overflow-hidden z-index-2">
              <div className="ps-lg-0 my-auto">
                <div className="card-body">
                  <h5 className="mb-0">OPTION TRACK 1: Malaria Surveillance </h5>
                  <p className="mb-0">
                    This track contains modules on basic concepts of malaria
                    surveillance, case detection and response, surveillance in
                    malaria control for moderate/high- and low-transmission
                    settings, surveillance for pre-elimination, and evaluating a
                    surveillance system.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-6 col-12">
            <div className="card card-profile overflow-hidden z-index-2">
              <div className="ps-lg-0 my-auto">
                <div className="card-body">
                  <h5 className="mb-0">
                    OPTION TRACK 2: Evaluation Methods for Malaria{" "}
                  </h5>
                  <p className="mb-0">
                    This track includes modules on basic concepts of evaluation,
                    statistical concepts, process evaluation, impact evaluation,
                    and practical applications of evaluation in malaria
                    programs.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="position-absolute w-100 bottom-0 mn-n1">
        <svg
          width="100%"
          viewBox="0 -1 1920 166"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <title>wave-up</title>
          <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g
              transform="translate(0.000000, 5.000000)"
              fill="#FFFFFF"
              fillRule="nonzero"
            >
              <g id="wave-up" transform="translate(0.000000, -5.000000)">
                <path
                  d="M0,70 C298.666667,105.333333 618.666667,95 960,39 C1301.33333,-17 1621.33333,-11.3333333 1920,56 L1920,165 L0,165 L0,70 Z"
                  fill="#ffffff"
                />
              </g>
            </g>
          </g>
        </svg>
      </div>
    </section>
  );
};

export default CourseContent;
